
import { mapState } from 'vuex' // 引入mapState
import userHeader from '~/components/login/userHeader.vue' // 头部
import wikiGeet from '~/components/common/wikiGeet.vue' // 极验
export default {
  components: {
    'user-header': userHeader,
    'wiki-geet': wikiGeet
  },
  props: {
    title: {
      type: String,
      default: '验证码'
    },
    phone: {
      type: [Number, String],
      default: '未传入手机号'
    },
    email: {
      type: String,
      default: ''
    },
    countOrnot: {
      type: Boolean,
      default: true
    },
    voiceState: {
      type: Boolean,
      default: true
    },
    isVercode: {
      type: Boolean,
      default: true
    },
    canIskip: {
      // 是否可以跳过
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      txtpass: {
        // 验证码
        one: '',
        two: '',
        tree: '',
        four: ''
      },
      smsCode: '', // 验证码
      showKeyboard: true, // 是否聚焦
      // 极验
      product: 'bind', // 极验展示效果
      showDrag: false, // 是否展示极验拖拽框
      verCode: '', // 验证码
      obtainState: this.countOrnot, // 获取状态
      countDown: 0, // 倒计时秒数
      LanguageCode: this.$store.state.LanguageCode, // 当前页面语言
      CountryCode: this.$store.state.CountryCode, // 国家
      countimes: 0, // 倒计时次数
      inst: 0 // 是否可删第三个
    }
  },
  computed: {
    ...mapState(['usergetCountry']) // 选中的国家
  },
  mounted() {
    // console.log('email', this.email)
    this.$nextTick(() => {
      if (this.obtainState) {
        // 是否倒计时
        this.countDown = 60
        this.startCount() // 开始倒计时
      }
      this.$refs.txtpass1.focus() // 获取焦点
    })
  },
  methods: {
    inpdel(i) {
      if (i == 1) {
        this.txtpass.one = ''
        this.$refs.txtpass1.focus()
      } else if (i == 2) {
        this.txtpass.two = ''
        this.txtpass.one = ''
        this.$refs.txtpass1.focus()
      } else if (i == 3) {
        this.txtpass.tree = ''
        this.txtpass.two = ''
        this.$refs.txtpass2.focus()
      } else if (i == 4) {
        this.inst = this.inst + 1
        if (this.inst == 2) {
          this.txtpass.tree = ''
          this.$refs.txtpass3.focus()
        }
      }
    },
    inputfocus(i) {
      if (i == 4 && this.txtpass.tree == '') this.$refs.txtpass3.focus()
      else if (i == 3 && this.txtpass.two == '') this.$refs.txtpass2.focus()
      else if (i == 2 && this.txtpass.one == '') this.$refs.txtpass1.focus()
      else if (i == 1 && this.txtpass.one != '') this.$refs.txtpass2.focus()
      else if (i == 2 && this.txtpass.two != '') this.$refs.txtpass3.focus()
      else if (i == 3 && this.txtpass.tree != '') this.$refs.txtpass4.focus()
    },
    getweebgeet() {
      this.showDrag = true
      setTimeout(() => {
        this.showDrag = false
      }, 500)
    },
    sendVCode(data = {}) {
      // 极验成功后发送验证码
      this.showDrag = false
      this.countDown = 60
      this.obtainState = true // 展示语音验证码按钮
      this.startCount() // 开始倒计时
      this.$emit('getvericode', data)
    },
    geetError() {
      // this.showDrag = false
      // this.$emit('geetError')
    },
    getSms() {
      // 开始倒计时
      this.obtainState = true
      this.countDown = 60
      this.startCount() // 开始倒计时
      this.$refs.txtpass1.focus() // 获取焦点
    },
    // 验证码登录——开始倒计时
    startCount() {
      this.countDown--
      if (this.countDown < 1) {
        // 倒计时结束
        clearTimeout(this.vTimer)
        this.countimes++
        this.obtainState = false // 展示语音验证码按钮
        return true
      }
      this.vTimer = setTimeout(this.startCount, 1000)
    },
    // 内容改变
    verificcode1() {
      this.txtpass.one = this.txtpass.one.replace(/[^\d]/g, '')
      if (this.txtpass.one != '' && this.txtpass.two != '' && this.txtpass.tree != '' && this.txtpass.four != '') {
        this.verCode = this.txtpass.one.concat(this.txtpass.two, this.txtpass.tree, this.txtpass.four)
        // console.log('this.verCode: ', this.verCode)
        this.$emit('getUsertion', this.verCode)
      }
      if (this.txtpass.one != '') this.$refs.txtpass2.focus()
    },
    verificcode2() {
      this.txtpass.two = this.txtpass.two.replace(/[^\d]/g, '')
      if (this.txtpass.one != '' && this.txtpass.two != '' && this.txtpass.tree != '' && this.txtpass.four != '') {
        this.verCode = this.txtpass.one.concat(this.txtpass.two, this.txtpass.tree, this.txtpass.four)
        // console.log('this.verCode: ', this.verCode)
        this.$emit('getUsertion', this.verCode)
      }
      if (this.txtpass.two != '') this.$refs.txtpass3.focus()
    },
    verificcode3() {
      this.txtpass.tree = this.txtpass.tree.replace(/[^\d]/g, '')
      if (this.txtpass.one != '' && this.txtpass.two != '' && this.txtpass.tree != '' && this.txtpass.four != '') {
        this.verCode = this.txtpass.one.concat(this.txtpass.two, this.txtpass.tree, this.txtpass.four)
        // console.log('this.verCode: ', this.verCode)
        this.$emit('getUsertion', this.verCode)
      }
      if (this.txtpass.tree != '') {
        this.inst = 1
        this.$refs.txtpass4.focus()
      }
    },
    async verificcode4() {
      this.txtpass.four = this.txtpass.four.replace(/[^\d]/g, '')
      if (this.txtpass.one != '' && this.txtpass.two != '' && this.txtpass.tree != '' && this.txtpass.four != '') {
        this.inst = 0
        this.verCode = this.txtpass.one.concat(this.txtpass.two, this.txtpass.tree, this.txtpass.four)
        if (this.isVercode) {
          // 校验验证码是否正确
          const {
            succeed = false,
            extra = '',
            result = {}
          } = await this.$api.login.userVerifysms({
            AreaCode: this.usergetCountry.code,
            PhoneNumber: this.phone,
            Smscode: this.verCode,
            ApplicationType: 7,
            ValidateSmsCodeType: 3,
            LanguageCode: this.LanguageCode
          })
          if (!succeed) return console.log(extra) // 数据错误
          console.log('result: ', result)
          console.log('extra: ', extra)
          console.log('succeed: ', succeed)
          console.log('this.verCode: ', this.verCode)
        }
        this.$emit('getUsertion', this.verCode)
      }
      // if (this.txtpass.four != '') this.$refs.txtpass4.blur()
    }
  }
}
